// Copyright (c) StrangeBee 2023

import {
    PAPLabelArray,
    PAPValueArray,
    PAPValues,
    SeverityLabelArray,
    SeverityValueArray,
    SeverityValues,
    TLPLabelArray,
    TLPValueArray,
    TLPValues,
} from 'thehive-sdk';
import { PAPColors, SeverityColors, TLPColors } from '@Constants/colors';
import { ColorsType, SecurityTagType } from '@Types';

type SecurityTagsReturn = { label: string; value: TLPValues | PAPValues | SeverityValues; color: ColorsType }[];

export const SecurityTags: (
    hasLabel: boolean,
    hasFullSeverityLabel?: boolean,
) => Record<SecurityTagType, SecurityTagsReturn> = (hasLabel: boolean, hasFullSeverityLabel?: boolean) => ({
    tlp: TLPValueArray.map((value, index) => ({
        label: (hasLabel ? 'TLP:' : '') + TLPLabelArray[index].toUpperCase(),
        value,
        color: TLPColors[index],
    })),
    pap: PAPValueArray.map((value, index) => ({
        label: (hasLabel ? 'PAP:' : '') + PAPLabelArray[index].toUpperCase(),
        value,
        color: PAPColors[index],
    })),
    severity: SeverityValueArray.map((value, index) => ({
        label:
            (hasLabel ? (hasFullSeverityLabel ? 'SEVERITY:' : 'SEV:') : '') + SeverityLabelArray[index].toUpperCase(),
        value,
        color: SeverityColors[index],
    })),
});
